var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.slug)?_c('div',[_c('listItems',{attrs:{"slug":_vm.slug}})],1):_vm._e(),(!_vm.slug)?_c('div',[_vm._v(" Landing page ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }